if (!window.customElements.get('product-description-toggle')) {
class ProductDescriptionToggle extends HTMLElement {
  static DESKTOP_MEDIA_QUERY = '(min-width: 700px)';

  connectedCallback() {
    this.description = this.closest('.truncated-content');
    this.content = this.description?.querySelector('.truncated-content__content');
    this.textEl = this.querySelector('.truncated-content__toggle-text');

    if (!this.description || !this.content || !this.textEl) {
      return;
    }

    this.moreText = this.dataset.readMore || 'Read more';
    this.lessText = this.dataset.readLess || 'Read less';
    this.desktopMediaQuery = window.matchMedia(ProductDescriptionToggle.DESKTOP_MEDIA_QUERY);
    this.onViewportChange = () => this.updateVisibility();

    requestAnimationFrame(() => this.init());
  }

  init() {
    this.addEventListener('click', this.onToggle);
    this.addEventListener('keydown', this.onKeyDown);
    this.desktopMediaQuery.addEventListener('change', this.onViewportChange);
    this.updateVisibility();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onToggle);
    this.removeEventListener('keydown', this.onKeyDown);
    this.desktopMediaQuery?.removeEventListener('change', this.onViewportChange);
  }

  onToggle = () => {
    if (this.description.dataset.descriptionExpanded === 'true') {
      this.collapse();
    } else {
      this.expand();
    }
  };

  onKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onToggle();
    }
  };

  isClampEnabledForViewport() {
    const isDesktop = this.desktopMediaQuery.matches;

    return isDesktop
      ? this.description.dataset.clampDesktop === 'true'
      : this.description.dataset.clampMobile === 'true';
  }

  needsTruncation() {
    if (!this.isClampEnabledForViewport()) {
      return false;
    }

    this.description.dataset.descriptionExpanded = 'true';
    const fullHeight = this.content.offsetHeight;

    this.description.dataset.descriptionExpanded = 'false';
    const clampedHeight = this.content.offsetHeight;

    return fullHeight > clampedHeight + 1;
  }

  updateVisibility() {
    if (!this.needsTruncation()) {
      this.description.dataset.descriptionTruncated = 'false';
      this.hidden = true;
      this.removeAttribute('role');
      this.removeAttribute('tabindex');
      return;
    }

    this.description.dataset.descriptionTruncated = 'true';
    this.hidden = false;
    this.setAttribute('role', 'button');
    this.setAttribute('tabindex', '0');
    this.syncToggleState();
  }

  syncToggleState() {
    if (this.description.dataset.descriptionExpanded === 'true') {
      this.setAttribute('aria-expanded', 'true');
      this.textEl.textContent = this.lessText;
    } else {
      this.setAttribute('aria-expanded', 'false');
      this.textEl.textContent = this.moreText;
    }
  }

  collapse() {
    this.description.dataset.descriptionExpanded = 'false';
    this.syncToggleState();
  }

  expand() {
    this.description.dataset.descriptionExpanded = 'true';
    this.syncToggleState();
  }
}

  window.customElements.define('product-description-toggle', ProductDescriptionToggle);
}
